import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import {Input, Tooltip} from '@enos/dpl';
import _ from 'lodash';
import localeText from '@locale';
import Store from './store';
import securityStore from '~/stores/SecurityStore';
import sessionStore from '~/stores/SessionStore';
import {Mobile, DesktopOrTablet} from '~/components/Responsive';
import './index.less';
import './mobile.less';

let isOnComposition = false;

const ruleReg = {
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUM: /[0-9]/,
  SPECIAL: /[!@#%&*()[\]{}_=\-|]/
};

@observer
class CipherInput extends React.Component {
  constructor(props) {
    super(props);
    this.store = new Store();
  }

  renderRules = () => (
    <div>
      {sessionStore.isMobile ? <span>{localeText('SECURITY.TAB_CIPHER_RULES')}：</span> : ''}
      <div>
        <i
          className={
            this.store.inputValue.length >= securityStore.minLenght && this.store.inputValue.length <= 20
              ? 'dpl20_right_circle_so hightlight'
              : 'dpl20_right_circle_so'
          }
        />
        {localeText('SECURITY.TXT_LENGTH_HINT', securityStore.minLenght)}
      </div>

      {securityStore.passwordRules.includes('UPPERCASE') && (
        <div>
          <i className={ruleReg.UPPERCASE.test(this.store.inputValue) ? 'dpl20_right_circle_so hightlight' : 'dpl20_right_circle_so'} />
          {sessionStore.isMobile ? localeText('SECURITY.TXT_CIPHER_TYPE_UPPERCASE') : localeText('SECURITY.TXT_UPPERCASE_HINT')}
        </div>
      )}

      {securityStore.passwordRules.includes('LOWERCASE') && (
        <div>
          <i className={ruleReg.LOWERCASE.test(this.store.inputValue) ? 'dpl20_right_circle_so hightlight' : 'dpl20_right_circle_so'} />
          {sessionStore.isMobile ? localeText('SECURITY.TXT_CIPHER_TYPE_LOWERCASE') : localeText('SECURITY.TXT_LOWERCASE_HINT')}
        </div>
      )}

      {securityStore.passwordRules.includes('NUM') && (
        <div>
          <i className={ruleReg.NUM.test(this.store.inputValue) ? 'dpl20_right_circle_so hightlight' : 'dpl20_right_circle_so'} />
          {sessionStore.isMobile ? localeText('SECURITY.TXT_CIPHER_TYPE_NUMBER') : localeText('SECURITY.TXT_MUNBER_HINT')}
        </div>
      )}

      {securityStore.passwordRules.includes('SPECIAL') && (
        <div>
          <i className={ruleReg.SPECIAL.test(this.store.inputValue) ? 'dpl20_right_circle_so hightlight' : 'dpl20_right_circle_so'} />
          {sessionStore.isMobile ? localeText('SECURITY.TXT_CIPHER_TYPE_CHARACTER') : localeText('SECURITY.TXT_SPECIAL_CHARACTER_HINT')}
        </div>
      )}
    </div>
  );

  handleChange = (e) => {
    const {onChange} = this.props;
    if (!isOnComposition) {
      this.store.setInputVal(e.target.value.trim());
      const matchLengthLimit = this.store.inputValue.length >= securityStore.minLenght && this.store.inputValue.length <= 20;
      const matchRules = _.findKey(_.mapValues(securityStore.passwordRules, r => ruleReg[r].test(e.target.value)), o => o === false);
      if (matchLengthLimit && matchRules === undefined) {
        this.store.setValidate(true);
      } else {
        this.store.setValidate(false);
      }
    }

    onChange(e);
  };

  handleComposition = (e) => {
    if (e.type === 'compositionend') {
      isOnComposition = false;
      this.handleChange(e);
    } else {
      isOnComposition = true;
    }
  };

  validate() {
    return this.store.isValidate;
  }

  clearMatchStatus() {
    this.store.setInputVal('');
  }

  render() {
    const {placeholder, ...rest} = this.props;
    return (
      <Fragment>
        <DesktopOrTablet>
          <Tooltip title={this.renderRules()} placement='right' overlayClassName='password-rules-tooltip'>
            <Input
              className='password-rules'
              {...rest}
              placeholder={placeholder}
              onChange={this.handleChange}
              onCompositionStart={this.handleComposition}
              onCompositionUpdate={this.handleComposition}
              onCompositionEnd={this.handleComposition}
            />
          </Tooltip>
        </DesktopOrTablet>
        <Mobile>
          <Input
            className='password-rules'
            {...rest}
            placeholder={placeholder}
            onChange={this.handleChange}
            onCompositionStart={this.handleComposition}
            onCompositionUpdate={this.handleComposition}
            onCompositionEnd={this.handleComposition}
          />
          <div className='password-rules-mobile'>{this.renderRules()}</div>
        </Mobile>
      </Fragment>
    );
  }
}

export default CipherInput;
